import type { AxiosInstance } from "axios";
import { getAttributeOperations } from "./namespaces/attribute";
import { getAttributeValueOperations } from "./namespaces/attribute-value";
import { getAuthOperations } from "./namespaces/auth";
import { getBankingOperations } from "./namespaces/banking";
import { getBillOperations } from "./namespaces/bill";
import { getBookingOperations } from "./namespaces/booking";
import { getCategoryOperations } from "./namespaces/category";
import { getConditionOperations } from "./namespaces/condition";
import { getConfigNumberOperations } from "./namespaces/config-number";
import { getContactOperations } from "./namespaces/contact";
import { getCountryOperations } from "./namespaces/country";
import { getCustomerOperations } from "./namespaces/customer";
import { getCustomerGroupOperations } from "./namespaces/customer-group";
import { getDeliveryMethodOperations } from "./namespaces/delivery-method";
import { getDiscountOperations } from "./namespaces/discount";
import { getDiscountItemOperations } from "./namespaces/discount-item";
import { getLanguageOperations } from "./namespaces/language";
import { getManufacturerOperations } from "./namespaces/manufacturer";
import { getMarketplaceOperations } from "./namespaces/marketplace";
import { getNoteOperations } from "./namespaces/note";
import { getOrderOperations } from "./namespaces/order";
import { getSupplierProductHubOperations } from "./namespaces/supplier-product-hub";
import { getUserOperations } from "./namespaces/user";
import { getUserDataOperations } from "./namespaces/user-data";
import { getVariantOperations } from "./namespaces/variant";
import { getVoucherSerieOperations } from "./namespaces/voucher-serie";
import { getSystemOperations } from "./namespaces/system";
import { getAccountingPostingOperations } from "./namespaces/accounting-posting";
import { getProductsImportOperations } from "./namespaces/products-import";
import { getDocumentOperations } from "./namespaces/document";
import { getAccountingTemplateOperations } from "./namespaces/accounting-template";

export const createExonnApi = (client: AxiosInstance) => {
  return {
    accountingTemplate: getAccountingTemplateOperations(client),
    accountingPosting: getAccountingPostingOperations(client),
    attribute: getAttributeOperations(client),
    attributeValue: getAttributeValueOperations(client),
    auth: getAuthOperations(client),
    banking: getBankingOperations(client),
    bill: getBillOperations(client),
    booking: getBookingOperations(client),
    category: getCategoryOperations(client),
    condition: getConditionOperations(client),
    configNumber: getConfigNumberOperations(client),
    contact: getContactOperations(client),
    country: getCountryOperations(client),
    customer: getCustomerOperations(client),
    customerGroup: getCustomerGroupOperations(client),
    deliveryMethod: getDeliveryMethodOperations(client),
    discount: getDiscountOperations(client),
    discountItem: getDiscountItemOperations(client),
    document: getDocumentOperations(client),
    language: getLanguageOperations(client),
    manufacturer: getManufacturerOperations(client),
    marketplace: getMarketplaceOperations(client),
    note: getNoteOperations(client),
    order: getOrderOperations(client),
    supplierProductHub: getSupplierProductHubOperations(client),
    user: getUserOperations(client),
    userData: getUserDataOperations(client),
    variant: getVariantOperations(client),
    voucherSerie: getVoucherSerieOperations(client),
    productsImport: getProductsImportOperations(client),
    system: getSystemOperations(client),
    get client() {
      return client;
    },
  };
};

export type ExonnApi = ReturnType<typeof createExonnApi>;
